//-------------------------------------------------------------------------------------------------- Imports
import { useDispatch, useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import { useCallback, useEffect, useState } from "react";
import Loading from "../../components/Loading";
import InfoCardComponent from "../../components/InfoCardComponent";
import { doPortability, getValidatePortability, updatePortability } from "../../methods/Methods";
import { ResponseValidatePortability } from "../../types/common";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import _ from "lodash";
import { Button, Card, Col, Input, Row, Typography, Tooltip } from "antd";
import { StyleSheet } from "../../StyleSheet";
import "./Portability.css"
import { AppDispatch } from "../../stores/store";
import { AlertSliceInterface, clearAlert, setAlert, showAlert } from "../../stores/slices/alertSlice";
import PortabilityList from "./PortabilityList";
import { InfoCircleOutlined } from "@ant-design/icons";
const { Text } = Typography;

interface errorFieldsProps {
    phone: string,
    nip?: string,
    phoneTrans: string,
};

//-------------------------------------------------------------------------------------------------- View
const Portability = () => {
    const emptyErrorFields: errorFieldsProps = {
        phone: '',
        nip: '',
        phoneTrans: ''
    }
    const generalData = useSelector(getGeneralData);
    const [idCliente, setIdCliente] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [hasError, setHasError] = useState(false);
    const [message, setMessage] = useState("");
    const [dataPortability, setDataPortability] = useState<ResponseValidatePortability>();
    const [showForm, setShowForm] = useState<boolean>(false);
    const [nip, setNip] = useState("");
    const [phone1, setPhone1] = useState("");
    const [phoneTransitorio, setPhoneTransitorio] = useState("");
    const [updatePortabilityData, setUpdatePortabilityData] = useState(false);
    const [errorsEmptyFields, setErrorsEmptyFields] = useState<errorFieldsProps>(emptyErrorFields);
    const dispatch = useDispatch<AppDispatch>();

    const notes = "1.- “El Usuario acepta que con la firma de la presente Solicitud de Portabilidad manifiesta su consentimiento de terminar la relación contractual con su actual proveedor de servicios, únicamente en lo que respecta a los servicios de telecomunicaciones cuya prestación requiere de los números telefónicos a ser portados, a partir de la fecha efectiva en que se realice la portabilidad de los mismos”.\n";
    const notes2 = "2.- “El Usuario acepta que el portar sus(s) números, no lo exime del cumplimiento de las obligaciones que haya contraído por la relación contractual con su actual proveedor de servicios y en su caso con su proveedor de larga distancia internacional, por lo que de manera enunciativa, mas no limitativa, se compromete a pagar los adeudos pendientes, devolver los equipos de telecomunicaciones que sean propiedad del Proveedor Donador y pagar las penalizaciones por terminaciones anticipadas que, en su caso, se hubieran convenido”.\n";
    const notes3 = "3.- “El Usuario reconoce que la Portabilidad de(los) número(s) solicitada está sujeta al cumplimiento de todos los requisitos establecidos de las Reglas de Portabilidad”.\n";
    const notes4 = "4.- “El firmante declara bajo protesta de decir la verdad que los datos asentados en la presente solicitud y, en su caso, los documentos que la acompañan son verdaderos”.\n";
    const notes5 = "5.- “El Usuario reconoce que la Portabilidad se aplica únicamente del Servicio Fijo al Servicio Fijo; del Servicio Móvil al Servicio Móvil bajo la misma Modalidad de Contratación (“El Que Llama Paga” a “El Que Llama Paga” o, en su caso, de “El Que Recibe Paga” a “El Que Recibe Paga”); de un Servicio No Geográfico al mismo Servicio No Geográfico, y del Servicio de Acceso a la Red Pública Telefónica que proporcionan las redes del Servicio Móvil de Radiocomunicación Especializada de Flotillas, al Servicio Móvil bajo la modalidad de contratación “El Que Recibe Paga”.\n";
    const notes6 = "6.- “El horario para que el Usuario solicite el trámite de Portabilidad presentando al efecto el Formato de Solicitud de Portabilidad respectivo, será de las 11:00 horas a las 17:00 horas, de lunes a sábado. En caso de que la solicitud de portabilidad se presente después de las 17:00 horas del día respectivo o en día domingo, la solicitud se considerará como ingresada formalmente al Día Hábil siguiente”.\n";
    const notes7 = "7.- “Los Datos Personales del Usuario contenidos o que acompañen el Formato de Solicitud de Portabilidad, serán tratados con base en lo dispuesto por la Ley Federal de Protección de Datos Personales en Posesión de Particulares y exclusivamente podrán ser utilizados para la realización del trámite de portabilidad respectivo”.\n";
    const notes8 = "8.- “El consentimiento que en su caso hubiere otorgado previamente el Usuario al Proveedor Donador u Concesionario Donador, para la recepción de llamadas de promoción de servicios o paquetes, en términos de lo establecido por el artículo 191 fracción XIX de la Ley, se tendrá por revocado con la presentación de esta solicitud”.";

    const getPortability = useCallback(async () => {
        if (idCliente) {
            setIsLoading(true);
            await getValidatePortability(idCliente)
                .then((response) => {
                    if (response && response.data && response.data.data[0] && response.data.data[0].respuesta === "true") {
                        setDataPortability(response.data.data[0])
                        if (response.data.data[0].estatus === "ACT") {
                            setHasError(true);
                            setMessage("Por el momento no es posible generar \nuna solicitud nueva ya que tiene una activa.")
                        }
                    } else {
                        setDataPortability(undefined);
                    }
                    setIsLoading(false);
                })
                .catch(() => {
                    setHasError(true);
                    setMessage("Hubo un error al procesar su solicitud. \nIntente más tarde.");
                    setIsLoading(false);
                })
        }
    }, [idCliente]);

    const validatePhone = (inputString: string) => {
        let valid = false;
        var reg = RegExp("^[0-9]{10}$");
        var result = reg.test(inputString);
        if (result)
            valid = true
        else
            valid = false
        return valid;
    }

    const handleChangeNip = (value: string) => {
        setNip(value);
        if (value) {
            errorsEmptyFields.nip = "";
        }
        if (value === "") {
            errorsEmptyFields.nip = "El nip está vacío.";
        }
        if (value.length < 4) {
            errorsEmptyFields.nip = "El campo Nip debe ser de 4 dígitos.";
        }
    }

    const handleChangePhone = (value: string) => {
        setPhone1(value);
        if (value) {
            errorsEmptyFields.phone = "";
        }
        if (value.length < 10) {
            errorsEmptyFields.phone = "El número telefónico debe contener 10 dígitos.";
        }
    }

    const handleChangePhoneTrans = (value: string) => {
        setPhoneTransitorio(value);
        if (value) {
            errorsEmptyFields.phoneTrans = "";
        }
        if (value.length < 10) {
            errorsEmptyFields.phoneTrans = "El número telefónico debe contener 10 dígitos.";
        }
    };

    const update = async () => {
        let objPortabilityData = {
            nip_personal: nip,
            telefono_portabilidad: phone1,
            telefono_transitorio: phoneTransitorio
        }

        let error = "";
        let allValidated = false;
        let validadoPhone = false;
        let validadoNip = false;
        let validadoPhoneTrans = false;

        let errorsFields: any = {
            phone: '',
            nip: '',
            phoneTrans: ''
        }

        if (_.isEmpty(phone1)) {
            let message = "El teléfono está vacío.\n";
            error += message
            errorsFields.phone = message;
        }
        else {
            let result = validatePhone(phone1);
            if (result)
                validadoPhone = true;
            else {
                let message = "El número telefónico debe contener 10 dígitos.\n";
                errorsFields.phone = message;
                error += message;
            }
        }

        if (nip === "") {
            let message = "El nip está vacío.\n";
            errorsFields.nip = message;
            error += message;

        } else {
            var regexValidate;
            var reg = RegExp("^[0-9]{4}$");
            regexValidate = reg.test(nip);
            if (!regexValidate) {
                let message = "El campo Nip debe ser de 4 dígitos.\n";
                errorsFields.nip = message;
                error += message;
            }
        }

        if (_.isEmpty(phoneTransitorio)) {
            let message = "El teléfono está vacío.\n";
            error += message
            errorsFields.phoneTrans = message;
        }
        else {
            let result = validatePhone(phoneTransitorio);
            if (result)
                validadoPhoneTrans = true;
            else {
                let message = "El número telefónico debe contener 10 dígitos.\n";
                errorsFields.phoneTrans = message;
                error += message;
            }
        }

        if (!_.isEmpty(nip) && regexValidate) {
            validadoNip = true;
        }


        setErrorsEmptyFields(errorsFields);
        if (validadoPhone && validadoNip && validadoPhoneTrans) {
            allValidated = true;
        }

        if (allValidated) {
            let typeAlert = "";
            let subtitleAlert = "";
            let messageAlert = "";

            setIsLoading(true);
            await updatePortability(objPortabilityData, idCliente)
                .then((response) => {
                    if (response && response.data && response.data.data[0] && response.data.data[0].respuesta === "true") {
                        typeAlert = "SUCCESS";
                        subtitleAlert = "¡Solicitud Exitosa!"
                        messageAlert = response.data.data[0].mensaje;
                    }
                    if (response && response.data && response.data.data[0] && response.data.data[0].respuesta === "false") {
                        typeAlert = "ERROR";
                        subtitleAlert = "Error al Generar Solicitud"
                        messageAlert = response.data.data[0].mensaje;
                    }
                    let dispatchAlert: AlertSliceInterface = {
                        show: true,
                        type: typeAlert as "INFO" | "SUCCESS" | "ERROR",
                        title: "¡Estimado Usuario!",
                        subtitle: subtitleAlert,
                        message: messageAlert,
                        onFinalize: () => handleDispatchAlertModal()
                    }
                    openAlertModal(dispatchAlert);
                    setIsLoading(false);
                })
                .catch(() => {
                    let dispatchAlert: AlertSliceInterface = {
                        show: true,
                        type: "ERROR",
                        title: "¡Estimado Usuario!",
                        message: "Hubo un error al procesar su solicitud. \nIntente más tarde.",
                        onFinalize: () => handleDispatchAlertModal()
                    }
                    openAlertModal(dispatchAlert);
                    setIsLoading(false);
                })
        } else {
            let dispatchAlert: AlertSliceInterface = {
                show: true,
                type: "ERROR",
                title: "¡Estimado Usuario!",
                message: error,
                onFinalize: () => handleDispatchAlertModal()
            }
            openAlertModal(dispatchAlert);
        }
    };

    const validate = async () => {
        let error = "";
        let allValidated = false;
        let validadoPhone = false;
        let validadoNip = false;
        let validadoPhoneTrans = false;

        let errorsFields: any = {
            phone: '',
            nip: '',
            phoneTrans: '',
        }

        if (_.isEmpty(phone1)) {
            let message = "El teléfono está vacío.\n";
            error += message;
            errorsFields.phone = message;
        }
        else {
            let result = validatePhone(phone1);
            if (result)
                validadoPhone = true;
            else {
                let message = "El número telefónico debe contener 10 dígitos.\n";
                error += message;
                errorsFields.phone = message;
            }
        }

        if (_.isEmpty(phoneTransitorio)) {
            let message = "El teléfono transitorio está vacío.\n";
            error += message;
            errorsFields.phoneTrans = message;
        }
        else {
            let result = validatePhone(phoneTransitorio);
            if (result)
                validadoPhoneTrans = true;
            else {
                let message = "El número telefónico debe contener 10 dígitos.\n";
                error += message;
                errorsFields.phoneTrans = message;
            }
        }

        if (nip === "") {
            let message = "El nip está vacío.\n";
            error += message;
            errorsFields.nip = message;
        }
        else {
            var regexValidate;
            var reg = RegExp("^[0-9]{4}$");
            regexValidate = reg.test(nip);
            if (!regexValidate) {
                let message = "El campo Nip debe ser de 4 dígitos.\n";
                error += message;
                errorsFields.nip = message;
            }
        }
        if (!_.isEmpty(nip) && regexValidate) {
            validadoNip = true;
        }

        setErrorsEmptyFields(errorsFields);

        if (error !== "") {
            setMessage(error);
        }

        if (validadoPhone && validadoNip && validadoPhoneTrans) {
            allValidated = true;
        }

        if (allValidated) {

            let objPortabilityData = {
                nip_personal: nip,
                telefono_portabilidad: phone1,
                telefono_transitorio: phoneTransitorio
            }
            let typeAlert = "";
            let subtitleAlert = "";
            let messageAlert = "";
            setIsLoading(true);
            await doPortability(objPortabilityData, idCliente)
                .then((response) => {
                    if (response && response.data && response.data.data[0] && response.data.data[0].respuesta === "true") {
                        typeAlert = "SUCCESS";
                        subtitleAlert = "¡Solicitud Exitosa!"
                        messageAlert = response.data.data[0].mensaje;
                    }
                    if (response && response.data && response.data.data[0] && response.data.data[0].respuesta === "false") {
                        typeAlert = "ERROR";
                        subtitleAlert = "Error al Generar Solicitud Nueva";
                        messageAlert = response.data.data[0].mensaje;
                    }
                    let dispatchAlert: AlertSliceInterface = {
                        show: true,
                        type: typeAlert as "INFO" | "SUCCESS" | "ERROR",
                        title: "¡Estimado Usuario!",
                        subtitle: subtitleAlert,
                        message: messageAlert,
                        onFinalize: () => handleDispatchAlertModal()
                    }
                    openAlertModal(dispatchAlert);
                    setIsLoading(false);
                })
                .catch(() => {
                    let dispatchAlert: AlertSliceInterface = {
                        show: true,
                        type: "ERROR",
                        title: "¡Estimado Usuario!",
                        message: "Hubo un error al procesar su solicitud. \nIntente más tarde.",
                        onFinalize: () => handleDispatchAlertModal()
                    }
                    openAlertModal(dispatchAlert);
                    setIsLoading(false);
                })
        } else {
            let dispatchAlert: AlertSliceInterface = {
                show: true,
                type: "ERROR",
                title: "¡Estimado Usuario!",
                message: error,
                onFinalize: () => handleDispatchAlertModal()
            }
            openAlertModal(dispatchAlert);
        }
    };

    const handleDispatchAlertModal = useCallback(() => {
        dispatch(showAlert(false));
        dispatch(clearAlert());
    }, [dispatch]);

    const openAlertModal = useCallback((option: AlertSliceInterface) => {
        dispatch(setAlert({
            show: option.show,
            type: option.type as "INFO" | "SUCCESS" | "ERROR",
            title: option.title,
            subtitle: option.subtitle,
            message: option.message,
            extraComponents: option.extraComponents,
            onFinalize: option.onFinalize
        }));
    }, [dispatch]);

    useEffect(() => {
        if (generalData.selectedContract !== null) {
            setIdCliente(
                generalData.selectedContract.sucursal + generalData.selectedContract.suscriptor
            );
        }
    }, [generalData.selectedContract]);

    useEffect(() => {
        if (idCliente && !_.isEmpty(idCliente)) {
            setMessage("");
            setHasError(false);
            setShowForm(false);
            getPortability();
        }
    }, [idCliente, getPortability]);

    useEffect(() => {
        if (!_.isEmpty(dataPortability)) {
            if (dataPortability.respuesta && dataPortability.respuesta === "true" && (dataPortability.estatus === "PRO" || dataPortability.estatus === "POR")) {
                setUpdatePortabilityData(true);
                setNip(dataPortability.datos.nip_personal);
                setPhone1(dataPortability.datos.telefono_portabilidad);
                setPhoneTransitorio(dataPortability.datos.telefono_transitorio);
            }
        }
    }, [dataPortability, idCliente]);

    return (
        <>
            {
                isLoading ?
                    <Loading />
                    :
                    <SubDefaultLayout
                        title={"Porta tu línea"}
                        needReturn={true}
                        navigateTo={"/my-data"}
                    >
                        <Row style={styles.centeredRow}>
                            {
                                hasError ?
                                    <InfoCardComponent title="¡Estimado usuario!" description={message} />
                                    :
                                    showForm ?
                                        <Col xs={24}>
                                            <Card style={styles.card}>
                                                <div style={{ marginTop: 30 }}>
                                                    <Row gutter={[24, 24]} style={{ marginTop: 20 }}>
                                                        <Col xs={12} xl={8}>
                                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                                <Text style={styles.inputTitle}>
                                                                    Nip
                                                                </Text>
                                                                <Input
                                                                    value={nip}
                                                                    style={styles.inputText}
                                                                    placeholder='Nip'
                                                                    onChange={(element) => handleChangeNip(element.target.value.replace(/[^0-9]/g, ''))}
                                                                    status={errorsEmptyFields.nip ? "error" : ""}
                                                                    maxLength={4}
                                                                />
                                                                {<Text type="danger" style={styles.emptyFieldError}>{errorsEmptyFields.nip ? errorsEmptyFields.nip : ""}</Text>}
                                                            </div>
                                                        </Col>
                                                        <Col xs={12} xl={8}>
                                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                                <Text style={styles.inputTitle}>
                                                                    Teléfono a Portar
                                                                </Text>
                                                                <Input
                                                                    value={phone1}
                                                                    style={styles.inputText}
                                                                    placeholder='Teléfono a Portar'
                                                                    onChange={(element) => handleChangePhone(element.target.value.replace(/[^0-9]/g, ''))}
                                                                    status={errorsEmptyFields.phone ? "error" : ""}
                                                                    maxLength={10}
                                                                />
                                                                {<Text type="danger" style={styles.emptyFieldError}>{errorsEmptyFields.phone ? errorsEmptyFields.phone : ""}</Text>}
                                                            </div>
                                                        </Col>
                                                        <Col xs={12} xl={8}>
                                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                                <Text style={styles.inputTitle}>
                                                                    Teléfono Transitorio
                                                                </Text>
                                                                <Input
                                                                    value={phoneTransitorio}
                                                                    style={styles.inputText}
                                                                    placeholder='Teléfono Transitorio'
                                                                    onChange={(element) => handleChangePhoneTrans(element.target.value.replace(/[^0-9]/g, ''))}
                                                                    status={errorsEmptyFields.phone ? "error" : ""}
                                                                    maxLength={10}
                                                                    suffix={
                                                                        <Tooltip title={`Se refiere al número de celular que tiene el chip de Megamóvil al que se va a reemplazar.`}>
                                                                            <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                                                        </Tooltip>
                                                                    }
                                                                />
                                                                {<Text type="danger" style={styles.emptyFieldError}>{errorsEmptyFields.phoneTrans ? errorsEmptyFields.phoneTrans : ""}</Text>}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div style={{ marginTop: 30 }}>
                                                    <Text style={styles.textTitle}>
                                                        Notas
                                                    </Text>
                                                    <Row style={{ marginTop: 20 }}>
                                                        <Col xs={24}>
                                                            <Text style={{ display: 'flex', textAlign: 'justify', fontSize: 13 }}>
                                                                {notes} <br /> {notes2} <br /> {notes3} <br /> {notes4} <br /> {notes5} <br /> {notes6} <br /> {notes7} <br /> {notes8}
                                                            </Text>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div style={{ marginTop: 30, display: "flex", justifyContent: 'flex-end', }}>
                                                    <Button
                                                        size='large'
                                                        style={styles.buttonPrimary}
                                                        onClick={() => updatePortabilityData ? update() : validate()}
                                                    >
                                                        {
                                                            !updatePortabilityData ?
                                                                "Guardar"
                                                                :
                                                                "Actualizar"
                                                        }
                                                    </Button>
                                                </div>
                                            </Card>
                                        </Col>
                                        :
                                        <Col xs={24} lg={12}>
                                            <Card style={styles.card}>
                                                <Row style={styles.cardInterior}>
                                                    <Text style={styles.textTitle}>
                                                        ¡Estimado suscriptor!
                                                    </Text>
                                                    <Text style={styles.textContent}>
                                                        Antes de comenzar a llenar el formulario de
                                                        portabilidad, puede consultar los beneficios
                                                        y requisitos en:
                                                    </Text>
                                                    <Text
                                                        style={styles.textLink}
                                                        onClick={() => (window.open("https://www.megacable.com.mx/telefonia"))}
                                                    >
                                                        https://www.megacable.com.mx/telefonia
                                                    </Text>
                                                </Row>
                                            </Card>
                                            <div style={styles.buttonContainer}>
                                                <Button
                                                    size='large'
                                                    style={styles.buttonPrimary}
                                                    onClick={() => setShowForm(true)}
                                                >
                                                    Iniciar Trámite
                                                </Button>
                                            </div>
                                        </Col>
                            }
                        </Row>
                        <PortabilityList />
                    </SubDefaultLayout>
            }
        </>
    )
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    centeredRow: {
        justifyContent: "center",
        marginTop: 20,
        marginBottom: 20
    },
    card: {
        backgroundColor: "white",
        borderRadius: 15,
        boxShadow: "0px 0px 8px #00000029",
        border: "none",
        display: "flex",
        flexDirection: "column",
        padding: 20
    },
    cardInterior: {
        justifyContent: "center",
        textAlign: "center"
    },
    textTitle: {
        color: "#000000",
        fontWeight: 600,
        fontSize: 16
    },
    textContent: {
        marginTop: 10
    },
    textLink: {
        marginTop: 10,
        cursor: "pointer",
        textDecoration: "underline",
        color: "#287dd2"
    },
    buttonPrimary: {
        backgroundColor: '#0055c2',
        borderRadius: 30,
        color: 'white',
        border: "none",
        padding: "5px 30px",
        height: 35
    },
    buttonContainer: {
        marginTop: 20,
        display: "flex",
        justifyContent: "center"
    },
    inputTitle: {
        color: "#0055c2",
        fontWeight: 600,
        fontSize: 12
    },
    inputText: {
        marginTop: 15,
        color: "#000000",
        borderColor: '#000000',
        fontSize: 12
    },
    emptyFieldError: {
        fontSize: 11
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default Portability;
